import {usePageModelsStore} from "@/store/modules/pageModels";
import {storeToRefs} from "pinia";
import {deepClone, getUrlParams, StorageUtils} from "xmgoing-utils";
import {qiankunWindow} from "vite-plugin-qiankun/dist/helper";
import {CurrentUtils} from "xmgoing-server";
import {PageEnum} from "@/enums/pageEnum";
import {getTotalValueList} from "@/main-page/jsParseEngine/ViewModel";

const fhAry = [
  '!=='
];

/**
 * 获取路径参数值
 * @param vuexStr
 * @param route
 */
export function getUrlParamsVal(vuexStr, route) {
  const parAry = (vuexStr + '').split("#{urlParams.");
  if (parAry && parAry[1]) {
    const paramName = (parAry[1] + '').split("}")[0];
    if (paramName) {
      if (!(qiankunWindow.__POWERED_BY_QIANKUN__)) {
        return getUrlParams(paramName, true);
      } else {
        const queryObj: any = route.query;
        return queryObj[paramName];
      }
    }
  }
}

function getHasStateStr(propAry) {
  return propAry?.filter((propStyr) => (propStyr + '').indexOf("state.") >= 0) || [];
}

/**
 * 从 vuex 表达式中提取 state 依赖路径，如 copyjpioldcpssjgapssclcpssinaasshfjh.receiptDetailSubtable
 */
function extractStateDepsFromVuexStr(vuexStr: string): string[] {
  const paths = new Set<string>();
  const regex = /vuex\.state\.([\w]+(?:\.[\w]+)*)/g;
  let match;
  while ((match = regex.exec(vuexStr + '')) !== null) {
    paths.add(match[1]);
  }
  return Array.from(paths);
}

function getStateValueByPath(state: any, path: string) {
  const parts = path.split('.');
  let val = unref(state);
  for (const part of parts) {
    if (val == null) {
      return val;
    }
    val = val[part];
  }
  return val;
}

function watchStatePath(state: any, path: string, callback: () => void) {
  watch(
    () => getStateValueByPath(state, path),
    () => {
      nextTick(callback);
    },
    {deep: true},
  );
}

/** 是否为子表合计类 defaultSetVuex 表达式 */
export function isVuexTotalDefaultSet(vuexStr?: string) {
  return (vuexStr + '').indexOf('vuex.total') >= 0;
}

export const totalFun = function (listOld) {
  try {
    if (listOld && typeof listOld === 'string') {
      listOld = JSON.parse(listOld);
    }
  } catch (e) {
    console.warn('JSON parse error in totalFun:', e);
  }
  return getTotalValueList(deepClone(listOld));
}

/**
 * 初始化vuex厘米的值
 * @param route
 * @param vuexStr
 * @param propName
 */
export const _initVuexPropValFun = function (vuex, {route, vuexStr, propName, record, state, mesProConfig,recordData={}}: any) {
  if (vuexStr) {
    if ((vuexStr + '').indexOf("urlParams") >= 0 && route) {
      unref(vuex)[propName] = getUrlParamsVal(vuexStr, route);
    }
    try {
      const vuexObj: any = {recordData:recordData,state: unref(state), mesConfig: unref(mesProConfig), total: totalFun}
      if (unref(record)) {
        vuexObj['record'] = unref(record);
      }
      const fun = new Function("vuex", `return ${vuexStr}`);
      const evalResult = fun(vuexObj);
      if (evalResult != null) {
        unref(vuex)[propName] = evalResult;
      } else {
        if (unref(vuex)[propName] == null) {
          // xmTree默认值为' '空格的话，会有默认值，影响必填校验
          // vuex.total默认值设为''空字符串的话，会影响计算
          unref(vuex)[propName] = isVuexTotalDefaultSet(vuexStr) ? 0 : '';
        } else {
          unref(vuex)[propName] = evalResult;
        }
      }
    } catch (e) {
      console.error(e, "==initVuexPropVal==" + vuexStr)
    }
  }
}
interface IuseVuex{
  sectionConfig:any;
  record?:any;
  vuexProps:any;
}
export function useVuexState({sectionConfig, record, vuexProps}:IuseVuex) {
  const vuex = ref({});
  const pageModelsStore = usePageModelsStore();
  const {state} = storeToRefs(pageModelsStore);

  let mesProConfig = {}
  try {
    mesProConfig = JSON.parse(StorageUtils.getSessionItem("mesProConfig"))
  } catch (e) {
    mesProConfig = {};
  }

  const initVuexPropVal = function (vuexStr, propName, mesProConfig) {
    const route = useRoute();
    _initVuexPropValFun(vuex, {route, vuexStr, propName, record, state, mesProConfig});
  }

  vuexProps.forEach((propName: string) => {
    const vuexStr = unref(sectionConfig)[propName + 'Vuex'];
    if (vuexStr) {
      //有可能是表达式 也可能式函数 所以通过函数执行来获取其中的值
      if (typeof (vuexStr) === 'string') {
        initVuexPropVal(vuexStr, propName, mesProConfig);
      }
      const wartChProp: any = [];
      //如果存在record对象
      if (unref(record) && vuexStr.indexOf("record.") > 0) {
        watch(()=>unref(record), () => {
          nextTick(() => {
            initVuexPropVal(vuexStr, propName, mesProConfig);
          })
        }, { deep: true });
      }

      const stateDeps = extractStateDepsFromVuexStr(vuexStr);
      if (stateDeps.length > 0) {
        stateDeps.forEach((statePath) => {
          watchStatePath(state, statePath, () => {
            initVuexPropVal(vuexStr, propName, mesProConfig);
          });
        });
      } else {
        const stateAry = getHasStateStr((vuexStr + '').trim().split("vuex."));
        stateAry.forEach((stateStr) => {
          fhAry.forEach((fhStr) => {
            //包含咯解析符号字符串
            const strAry = stateStr.split(fhStr);
            let propNameNew = (strAry[0] + '').trim().replace(/state./, "");
            propNameNew = (propNameNew + '').trim().replace(/&&/, "");
            if (propNameNew.indexOf("!==") > 0) {
              propNameNew = propNameNew.split("!==")[0];
            }
            if (propNameNew.indexOf(".indexOf") > 0) {
              propNameNew = propNameNew.split(".indexOf")[0];
            }
            const splitAryChar = ['.indexOf', '!=', '===', '==', '=', '+', '-', '/', '*', ')', '||'];
            splitAryChar.forEach((charItem) => {
              if (propNameNew.indexOf(charItem) > 0) {
                propNameNew = propNameNew.split(charItem)[0];
              }
            })
            if (!(wartChProp.findIndex(ele => ele === propNameNew) >= 0)) {
              wartChProp.push(propNameNew);
            }
          })
        })
        //如果定义了 状态变量
        wartChProp.forEach((stateProp) => {
          if ((stateProp + '').indexOf(".") > 0) {
            watchStatePath(state, stateProp, () => {
              initVuexPropVal(vuexStr, propName, mesProConfig);
            });
          } else {
            try {
              //监听状态变化
              watch(() => unref(state)[stateProp], (newValue) => {
                nextTick(() => {
                  initVuexPropVal(vuexStr, propName, mesProConfig);
                })
              });
            } catch (e) {
              console.error(e, "=========")
            }
          }
        })
      }
    } else {
      /**
       * 监听对象显示、隐藏状态
       */
      watch(() => unref(sectionConfig)[propName], (newValue) => {
        unref(vuex)[propName] = newValue;
      }, {deep: true})
      unref(vuex)[propName] = unref(sectionConfig)[propName];
    }
  })


  /**
   * 是否总部可见的开关
   */
  const isRootAcl = computed(() => {
    //判断是否打开了总部可见的开关
    if ((unref(sectionConfig).showFlagIsRoot + '') === 'true') {
      let curUserTenantId = "";
      CurrentUtils._loadUser(false, (user) => {
        curUserTenantId = user['tenantId']
      })
      if (curUserTenantId === PageEnum.GROUP_TenantId) {
        return true;
      }
      return false;
    }
    return true;
  })

  const getItemDis = function (itemConfig, recordData = {}) {
    const backVuex=ref({disabled:false});
    if(itemConfig['disabledVuex']){
      _initVuexPropValFun(backVuex, {propName: 'disabled', vuexStr: itemConfig['disabledVuex'], recordData, state});
    }
    return unref(backVuex).disabled;
  }

  /**
   * 获取某个项 是否显示
   * @param itemConfig
   */
  const getItemShow=function (itemConfig,recordData){
    const backVuex=ref({showCtl:true});
    if(itemConfig['showCtlVuex']){
      _initVuexPropValFun(backVuex, {propName: 'showCtl', vuexStr: itemConfig['showCtlVuex'],recordData,state});
    }
    return unref(backVuex).showCtl;
  }

  /**
   * 根据vuexStr进行设置
   * @param vuexStr
   * @param recordData
   */
  const getItemShowFlag=function (vuexStr,recordData){
    const backVuex=ref({showCtl:true});
    if(vuexStr){
      _initVuexPropValFun(backVuex, {propName: 'showCtl', vuexStr,recordData,state});
    }
    return unref(backVuex).showCtl;
  }

  return {
    getItemShowFlag,
    getItemShow,
    getItemDis,
    initVuexPropVal,
    isRootAcl,
    stateProps: state,
    vuex
  }
}
